import { render, staticRenderFns } from "./GrupoPreparacao.vue?vue&type=template&id=d72630da&"
import script from "./GrupoPreparacao.vue?vue&type=script&lang=js&"
export * from "./GrupoPreparacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports